export const Platform = {
    sms: 'sms',
    mms: 'mms',
    whatsapp: 'whatsapp'
};
